import { useDispatch } from 'react-redux';
import { userActions } from '@/store/user';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';

export const LogOutButton = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onLogout = () => {
    dispatch(userActions.logout());
  };
  return (
    <div>
      <Button type='link' size='large'onClick={onLogout}>{t('Logout')}</Button>
    </div>
  );
};
